import { initialState } from './selectors'
/* ---------------------------- Define Actions ------------------------------ */
export default (state = initialState, { type, payload }) => {
    switch (type) {
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/application/interface/store/departments/theme/reducer.js